import { render, staticRenderFns } from "./ProfanityFilterWhitelist.vue?vue&type=template&id=972c677e&"
import script from "./ProfanityFilterWhitelist.vue?vue&type=script&lang=js&"
export * from "./ProfanityFilterWhitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports